import request from '@/utils/request'


// 查询发票列表
export function listInvoice(query) {
  return request({
    url: '/invoice/invoice/list',
    method: 'get',
    params: query
  })
}

// 查询发票分页
export function pageInvoice(query) {
  return request({
    url: '/invoice/invoice/page',
    method: 'get',
    params: query
  })
}

// 查询发票详细
export function getInvoice(data) {
  return request({
    url: '/invoice/invoice/detail',
    method: 'get',
    params: data
  })
}

// 新增发票
export function addInvoice(data) {
  return request({
    url: '/invoice/invoice/add',
    method: 'post',
    data: data
  })
}

// 修改发票
export function updateInvoice(data) {
  return request({
    url: '/invoice/invoice/edit',
    method: 'post',
    data: data
  })
}

// 删除发票
export function delInvoice(data) {
  return request({
    url: '/invoice/invoice/delete',
    method: 'post',
    data: data
  })
}
